<template>
  <div v-if="produitCollection || !isListeAuto" class="container-liste-liens">
    <Hyperlien
      v-if="content.lien"
      class="titre-liste-liens"
      :content="{
        texte: `${getTitre}` || '',
        type: 'lienTertiaire',
        lien: getLienTitre,
      }"
    />
    <EditableArea
      v-if="!isListeAuto"
      class="row no-gutters h-100 d-block pl-3 liste-liens"
      :content="content.listeLiens"
      :parentTemplateId="metadata['mgnl:template']"
    />
    <div v-else-if="produitCollection" class="row no-gutters h-100 d-block pl-3 liste-liens">
      <div v-for="produit in produits" :key="produit['@id']" class="d-flex">
        <Hyperlien
          :content="{
            texte: getTitreProduit(produit),
            type: 'lienTertiaire',
            lien: getLienProduit(produit),
          }"
        />
        <div
          v-if="
            content.isReglesDeJeux == 'true' &&
            (getPdf(produit).lienExterne || getPdf(produit).lienInterneAsset)
          "
          class="d-flex"
        >
          &nbsp;
          <Hyperlien
            :content="{
              texte: `| ${$t('regles')}`,
              type: 'lienTertiaire',
              lien: getPdf(produit),
            }"
          />
          &nbsp;
          <b-link
            :href="
              getPdf(produit).lienInterneAsset
                ? jel_getFichierSrc(getPdf(produit).lienInterneAsset)
                : getPdf(produit).lienExterne
            "
          >
            <svg-icon icon-name="ic-file"></svg-icon
            ><label class="sr-only">{{ $t('regles') }}</label>
          </b-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { inMgnl } from '@/helpers/AppHelpers';
import instant from '@/services/api/jel/jel';
import { EditableArea } from '@/vue-editor';
import { capitalizeFirstLetter } from '@/helpers/StringHelpers';
import Hyperlien from '@/components/base/Hyperlien';

export default {
  name: 'ListeLiens',
  components: {
    EditableArea,
    Hyperlien,
  },
  props: {
    metadata: { type: Object },
    isListeAuto: { type: Boolean },
    content: { type: Object, required: true },
  },
  data() {
    return {
      produit: [],
      instants: [],
    };
  },
  i18n: {
    messages: {
      fr: {
        regles: 'Règles',
      },
      en: {
        regles: 'Rules',
      },
    },
  },
  computed: {
    ...mapGetters({
      getLienInterneFromProduit: 'produitCasino/getLienInterneFromProduit',
      getProduitCollectionUuidByName: 'produitCollection/getUuidByName',
      getProduitCollectionByUuid: 'produitCollection/getByUuid',
      getArrayProduitByUuidProduitCollection:
        'produitCollection/getArrayProduitByUuidProduitCollection',
    }),
    getTitre() {
      if (this.content.collection) {
        const langue = capitalizeFirstLetter(this.$i18n.locale);
        return this.content.collection == 'instants'
          ? 'Instants'
          : this.produitCollection?.[`titreCollection${langue}`];
      }
      return this.content.titre || '';
    },
    getLienTitre() {
      return {
        field: 'lienExterne',
        isDejaNettoye: false,
        lienExterne: this.content.lien.lienExterne,
      };
    },
    produitCollection() {
      if (this.content.collection == 'instants') {
        return this.instants;
      }
      return this.getProduitCollectionByUuid(
        this.getProduitCollectionUuidByName(this.content.collection)
      );
    },
    produits() {
      if (this.content.collection == 'instants') {
        return this.instants;
      }
      return this.getArrayProduitByUuidProduitCollection(
        this.getProduitCollectionUuidByName(this.content.collection)
      );
    },
  },
  created() {
    if (this.content.collection == 'instants' && !inMgnl) {
      instant
        .getInstants()
        .then((instants) => {
          this.instants = instants;
        })
        .catch((error) => console.log(error));
    }
  },
  methods: {
    getLienProduit(produit) {
      return produit.lien
        ? { field: 'lienExterne', isDejaNettoye: true, lienExterne: produit.lien.slice(3) } // lien instant
        : this.getLienInterneFromProduit(produit); // lien autres
    },
    getPdf(produit) {
      return produit['lien-pdf']
        ? { field: 'lienExterne', isDejaNettoye: true, lienExterne: produit['lien-pdf'] }
        : {
            field: 'lienInterneAsset',
            lienInterneAsset: produit.listePdf?.listePdf0?.pdf,
          };
    },
    getTitreProduit(produit) {
      const langue = capitalizeFirstLetter(this.$i18n.locale);
      // eslint-disable-next-line no-nested-ternary
      const titre = produit[`titre${langue}`]
        ? produit[`titre${langue}`]
        : produit.titre
        ? produit.titre
        : '';
      let titreJeu = (produit[`prefixe${langue}`] ? `${produit[`prefixe${langue}`]} ` : '') + titre;
      if (produit[`exposant${langue}`]) {
        titreJeu += `<sup>${produit[`exposant${langue}`]}</sup>`;
      }
      return titreJeu;
    },
  },
};
</script>

<style lang="scss" scoped>
.container-liste-liens {
  margin-top: 20px;
  margin-left: 40px;
  border-bottom: 1px dotted black;
  padding-bottom: 16px;
}
.container-liste-liens:last-child {
  border-bottom: 0;
}
.container-liste-liens .container-liste-liens {
  margin: 0;
  border-bottom: 0;
  padding: 0;
}

.titre-liste-liens {
  font-size: 12px;
  font-weight: bold;
  line-height: 18px;
}

.titre-liste-liens ::v-deep span div {
  color: #004990;
}

.liste-liens .titre-liste-liens {
  font-weight: normal !important;
}

::v-deep .lienTertiaire {
  padding: 0 !important;
  font-size: 12px;
  line-height: 18px;
}

.liste-liens ::v-deep div {
  width: fit-content;
}
</style>
